export default __webpack_public_path__ + "static/media/Icon-django.456efe72.svg";